import React from "react";
// import image1 from '../../images/aboutslush.png';
import image2 from "../../images/WW-Hero-1.jpg";
import { Helmet } from "react-helmet";

import styles from "./index.module.css";

export default function FranchiseoppertunitiesPage() {
	return (
		<div className={styles.FranchiseoppertunitiesPage}>
			<Helmet>
				<title>Wet Willie's Franchise | Franchise Opportunities</title>
			</Helmet>
			<div className={styles.figureContainer}>
				<figure>
					<img src={image2} alt="" />
				</figure>
			</div>
			<div className={styles.header}>
				<h1>FRANCHISE OPPORTUNITIES</h1>
			</div>
			<div className={styles.articleContainer}>
				<article>
					<section className={styles.section2}>
						<h1>Why Wet Willie's</h1>
						<p>
							Wet Willie's is a concept that has developed strong
							brand recognition since 1991.
						</p>
						<br />
						<p>
							Wet Willie's produces superior frozen daiquiris
							resulting from the mix of premium alcoholic beverage
							products with unique, high quality flavors
							specifically selected and blended exclusively for
							Wet Willie's.
						</p>
						<br />
						<p>
							Wet Willie's daiquiris are frozen to the perfect
							temperature and are constantly blended in our
							daiquiri machines to ensure that our daiquiris
							always have the perfect temperature, consistency and
							uniform taste that is unique to Wet Willie's.
						</p>
						<br />
						<p>
							In every Wet Willie's there are between 20 and 30
							daiquiri machines offering a range of different
							flavors, a kaleidoscope of colors, and an
							opportunity for our customers to experiment making
							their own blends.
						</p>
						<br />
						<p>
							Our food items are prepared from quality
							ingredients. Overseen by our professional Chef, our
							recipes have been perfected for over three decades. Preparation is relatively uncomplicated and
							the results are superior. Systems have been
							established to assist in controlling food costs and
							inventories.
						</p>
						<br />
						<p>
							Our superior food and beverages are complimented by
							an equally superior environment. From our friendly,
							well-trained staff to our beautiful murals,
							everything about Wet Willie's spells FUN.
						</p>
						<br />
						<p>
							Our system is simple and efficient. Keeping things
							simple and keeping things moving is the cornerstone
							of the Wet Willie's system. Bartenders are able to
							produce any drink offered with the pull of a lever
							or the twist of a cap, and therefore it is not
							necessary for our bartenders to be mixologists. The
							system also allows for simple and precise inventory
							control.
						</p>
					</section>
				</article>
			</div>
		</div>
	);
}
